import { Component, JSX, h } from 'preact'
import { i18n } from 'i18n/i18n'

import { TransferFeesObj, ChosenItemTransfer } from 'models/exchange-transfer-calculate'

import selectHelper from 'app-utils/select-helper'

import SelectPreact, { SelectOption } from 'common-modules/select-preact/select-preact'

interface CalculatorSelectTransferProps {
  transferFees: TransferFeesObj[]
  chosenItem: ChosenItemTransfer
  onChange?: (option: SelectOption) => void
}

interface CalculatorSelectTransferState {
  options: SelectOption[]
  chosenItem: SelectOption
}

export default class CalculatorSelectTransfer extends Component<
  CalculatorSelectTransferProps,
  CalculatorSelectTransferState
> {
  public render() {
    return (
      <div className="hero-form__input-block">
        <div className="hero-form__input-block-label">
          <div className="hero-form__input-block-label-text">{i18n('calculatorForegin.foreignTransferType')}</div>
        </div>
        <div className="hero-form__dropdown-holder hero-form__dropdown-holder-select clearfix">
          <SelectPreact
            id="calculator-transfer-select"
            name="calculator-transfer-select"
            options={this.createDropdownOptions()}
            chosenItem={this.createSelectedOption()}
            onChange={this.props.onChange}
            buttonClasses={'in-hero-form-with-currency'}
            listClasses={'for-currency-big-dropdown'}
            isSearch={false}
          />
        </div>
      </div>
    )
  }

  public getTemplateDropdownOption = (fee: string, name: string, text: string): JSX.Element => (
    <div className="bem-select-dropdown__choice in-hero-form in-hero-form-select">
      <div className="transfer-type">
        {name} ({fee.replace(/\./g, ',')})
      </div>
      {text && <div className="transfer-type-desc">{text}</div>}
    </div>
  )

  public createSelectedOption = (): SelectOption => {
    const transferTypeLower = this.props.chosenItem.chosenItemTransferType.toLowerCase()
    return selectHelper.createOption(
      this.props.chosenItem.chosenItemTransferFee,
      this.getTemplateDropdownOption(
        this.props.chosenItem.chosenItemTransferFee,
        i18n(`transferTypes.${transferTypeLower}.header`) as unknown as string,
        '',
      ),
      this.props.chosenItem.chosenItemTransferType,
    )
  }

  public createDropdownOptions = (): SelectOption[] => {
    const options = this.props.transferFees.map((transfer) => {
      const transferTypeLower = transfer.transfer_type.toLowerCase()
      return selectHelper.createOption(
        transfer.fee,
        this.getTemplateDropdownOption(
          transfer.fee,
          i18n(`transferTypes.${transferTypeLower}.header`) as unknown as string,
          i18n(`transferTypes.${transferTypeLower}.subtext`) as unknown as string,
        ),
        transfer.transfer_type,
      )
    })

    return options.length ? options : [selectHelper.getEmptyOption()]
  }
}
